import OfflineChat from "~/components/OfflineChat";
import HelpBase from "./HelpBase";

import "./styles.scss";

type ChatHelperProps = {
  showOffChat: boolean;
  setShowOffChat: (value: boolean) => void;
};

const ChatHelper: React.FC<ChatHelperProps> = ({
  showOffChat,
  setShowOffChat,
}) => {
  return (
    <>
      {showOffChat ? (
        <OfflineChat />
      ) : (
        <HelpBase setShowOffChat={setShowOffChat} />
      )}
    </>
  );
};

export default ChatHelper;
